import { Card, message, Row, Space, Spin, Table, Typography } from 'antd';
import React, { useEffect } from 'react';
import useSWR from 'swr';

import PageHeader from '@/components/PageHeader';

import EditVendor from './components/EditVendor';
import { getOutsourcedVendors } from './helpers/api';
import { getColumns } from './helpers/ui';
import styles from './styles.module.scss';

const OutsourcedVendorsManagement: React.FC = () => {
  const {
    data: vendors,
    mutate,
    error,
    isLoading,
  } = useSWR('fetchOnceKeyWord', getOutsourcedVendors, {
    errorRetryCount: 0,
  });

  useEffect(() => {
    if (error) {
      console.error(error);
      message.error('資料讀取失敗，請重新整理頁面或稍後再試');
    }
  }, [error]);

  function updateTableData() {
    mutate();
  }

  const columns = getColumns(updateTableData);

  const dataSource = vendors?.map((vendor) => ({
    ...vendor,
    key: vendor._id,
  }));

  return (
    <Space direction="vertical" className={styles.pageContainer}>
      <PageHeader
        title="合作廠商資訊管理"
        breadcrumbs={[{ name: '帳號管理' }, { name: '合作廠商資訊管理' }]}
      />
      <EditVendor buttonLabel="新增廠商" updateVendors={updateTableData} />
      <Card>
        <Typography.Title level={4}>廠商資訊</Typography.Title>
        {!isLoading && (
          <Table
            dataSource={dataSource}
            columns={columns}
            bordered
            pagination={{
              hideOnSinglePage: true,
              pageSize: 10,
            }}
          />
        )}
        {isLoading && (
          <Row justify="center">
            <Spin />
          </Row>
        )}
      </Card>
    </Space>
  );
};

export default OutsourcedVendorsManagement;
